import angular from 'angular';
import _ from 'lodash';
import {fields} from './fields.js';
import swal from 'sweetalert';

class FormController {
    constructor(Model) {
        this.Model = Model;
        this.fields = this.getFields();
        this.model = this.model || {};
        this.clone = angular.copy(this.model);
        this.onSubmit = this.onSubmit || angular.noop;
        this.onCancel = this.onCancel || angular.noop;
    }

    submit() {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        this.Model.create(this.clone, {upsert: true}).then((data) => {
            swal("", "Podaci su uspiješno pohranjeni", "success");
            this.onSubmit({model: data});
        });
    }

    cancel() {
        if (this.form.$pristine) {
            this.onCancel();
            return;
        }
        swal({
            title: "Jeste li sigurni?",
            text: "Podaci nisu spremljeni. Želite li zatvoriti formu za unos?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "Da, zatvori!",
            cancelButtonText: 'Odustani',
            closeOnConfirm: true
        },
        () => this.onCancel());
    }

   getFields(){
        return [
            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Pacijent'
                },
                fieldGroup: [
                    {
                        className:'col-md-6',
                        fieldGroup: [
                            fields.prezime,
                            fields.ime,
                        ]
                    },
                    {
                        className: 'col-md-6',
                        fieldGroup: [
                            fields.adresa,
                            fields.datum_rodjenja,
                        ]
                    }
                ]
            },
            {
                wrapper:'fieldset',
                templateOptions: {
                    label: 'Pristanak'
                },
                fieldGroup: [
                    {
                        className:'col-md-8',
                        fieldGroup: [
                            _.merge({templateOptions: {focus: 'true'}}, fields.mjesto_rodjenja),
                            fields.datum_pristanka,
                            fields.naziv,
                            fields.pristanak,
                        ]
                    },
                ]
            }
        ];
    }
}

FormController.$inject = ['Pristanak'];

export {FormController};



// WEBPACK FOOTER //
// ./app/components/pristanak/form/form.controller.js